module.exports = __webpack_public_path__ + "img/6.1a7a0c70.png";